import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const SingleTrackIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Single track - narrow winding path */}
    <path d="M12 4c0 4-4 4-4 8s4 4 4 8" />
    <path d="M8 6c-2 1-4 2-4 4" />
    <path d="M16 14c2 1 4 2 4 4" />
    <circle cx="12" cy="4" r="1" />
    <circle cx="12" cy="20" r="1" />
  </svg>
);
